module.exports = __webpack_public_path__ + "img/brands-models-1.356e7621.jpg";